const BACK_BUTTON_VISIBLE_CLASSNAME = "d-flex";
const BACK_BUTTON_HIDDEN_CLASSNAME = "d-none";
const WORLD_MAP_OUTER_CONTAINER_ELEMENT_CLASSNAME =
  ".world-map__outer-container";

const worldMapBackButtonVisibilityIntersectionObserver =
  new IntersectionObserver(
    (intersections) => {
      for (const intersection of intersections) {
        const worldMapContainerElement = intersection.target.closest(
          WORLD_MAP_OUTER_CONTAINER_ELEMENT_CLASSNAME
        );

        if (worldMapContainerElement === null) {
          continue;
        }

        const backButtonElements =
          worldMapContainerElement.querySelectorAll(".map-back-button");

        if (intersection.isIntersecting) {
          for (const backButtonElement of backButtonElements) {
            backButtonElement.classList.add(BACK_BUTTON_VISIBLE_CLASSNAME);
            backButtonElement.classList.remove(BACK_BUTTON_HIDDEN_CLASSNAME);
          }
        } else {
          for (const backButtonElement of backButtonElements) {
            backButtonElement.classList.remove(BACK_BUTTON_VISIBLE_CLASSNAME);
            backButtonElement.classList.add(BACK_BUTTON_HIDDEN_CLASSNAME);
          }
        }
      }
    },
    {
      rootMargin: "-70% 0px -25% 0px",
    }
  );

export const initializeWorldMapBackButtonVisibilityHandling = (
  worldMapElement: HTMLElement
) => {
  const worldMapOuterContainerElement = worldMapElement.closest(
    WORLD_MAP_OUTER_CONTAINER_ELEMENT_CLASSNAME
  );

  if (worldMapOuterContainerElement === null) {
    throw new Error(
      "Cannot initialize back button visibility handling for world map element outside a wrapping .world-map__outer-container"
    );
  }

  for (const countryListContainerElement of worldMapOuterContainerElement.querySelectorAll(
    ".world-map-countries__container"
  )) {
    worldMapBackButtonVisibilityIntersectionObserver.observe(
      countryListContainerElement
    );
  }
};
